import { Layout, SitePlan as SitePlanComponent } from "components"
export const SitePlan = () => {
 return (
  <Layout>
   <SitePlanComponent />
  </Layout>
 )
}
